export default __webpack_public_path__ + "static/race-day-toddler-trot-square-69c098e89247c89612f3ca5d2d5e8147.png";